<template>
  <el-dialog
    :title="!dataForm.id ? '下次维修时间' : '检维修计划'"
    :close-on-click-modal="false"
    :visible.sync="visible"
    :before-close="closeHandle"
    width='530px'>
    <div v-if="dataForm.id">
      <div class="row">
        <span class="row-item-label">计划状态：</span>
        <label class="row-item-content">{{dataForm.overhaulStatus? dataForm.overhaulStatus === 1 ? '送审' : '完成' : '执行'}}</label>
      </div>
      <div class="row">
        <span class="row-item-label">维修日期：</span>
        <label class="row-item-content">{{dataForm.nextOverhaulTime}}</label>
      </div>
      <div class="row">
        <span class="row-item-label">维修内容：</span>
        <label class="row-item-content">{{dataForm.repairContent}}</label>
      </div>
      <div class="row">
        <span class="row-item-label">计划提醒设置：</span>
        <label class="row-item-content">提前{{dataForm.overhaulRemind? dataForm.overhaulRemind : '0'}}天提醒</label>
      </div>
      <div class="row">
        <span class="row-item-label">维保负责人：</span>
        <label class="row-item-content">{{dataForm.overhaulResponsible}}</label>
      </div>
      <div class="row">
        <span class="row-item-label" style="font-weight: bold;">检维修履历</span>
        <label class="row-item-content">&nbsp;</label>
      </div>
      <div class="row">
        <el-table :data="dataForm.flowingEntityList" style="position:relation">
          <el-table-column prop="overhaulStatus" header-align="center" align="center" label="" width="50">
            <template slot-scope="scope">
              <div v-if="(scope.$index + 1) !== dataForm.flowingEntityList.length" class="line" :style="(scope.$index + 1) === dataForm.flowingEntityList.length ? 'bottom:29px;': ''"></div>
              <div class="circular" :style="(scope.$index + 1) === dataForm.flowingEntityList.length ? 'background: #1D65A8': ''"></div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" header-align="center" align="center" label="时间"></el-table-column>
          <!-- <el-table-column prop="nextOverhaulTime" header-align="center" align="center" label="状态"></el-table-column> -->
          <el-table-column prop="overhaulStatus" header-align="center" align="center" label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.overhaulStatus === 0">执行</span>
              <span v-else-if="scope.row.overhaulStatus === 1">送审</span>
              <span v-else>完成</span>
            </template>
          </el-table-column>
          <!-- <el-table-column header-align="center" align="center" label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="detailHandle(scope.row)">详情</el-button>
              <el-button type="text" size="small" @click="repairInfoSS(scope.row)">送审</el-button>
            </template>
          </el-table-column> -->
        </el-table>
        <!-- <span class="row-item-label">检维修状态：</span> -->
      </div>
    </div>
    <span v-if="dataForm.id" slot="footer">
      <div class="butt close-but" @click="closeHandle()">关闭</div>
    </span>
    <el-form v-if="!dataForm.id" :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="110px">
      <el-form-item label="维保修内容" prop="repairContent">
        <el-input v-model="dataForm.repairContent" maxlength="500" :autosize="{ minRows: 3}" type="textarea" placeholder="维保修内容"></el-input>
      </el-form-item>
      <el-form-item label="下次维修日期" prop="nextOverhaulTime">
        <el-date-picker v-model="dataForm.nextOverhaulTime" :picker-options="pickerOptions" type="date" placeholder="选择日期时间" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
      </el-form-item>
      <el-form-item label="提醒设置" prop="overhaulRemind">
        <el-select v-model="dataForm.overhaulRemind" placeholder="请选择" clearable>
          <el-option
            v-for="item in overhaulList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="维保负责人" prop="overhaulResponsible">
        <el-input v-model="dataForm.overhaulResponsible" placeholder="检维修负责人" maxlength="50"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer" v-if="!dataForm.id">
      <div class="opt-but">
          <div :class="'upload-cancel '+(butLoading?'but-loading':'')" @click="visible = false">
            <i class="el-icon-loading" v-if="butLoading"></i>
            取消
          </div>
          <div :class="'upload-ok '+(butLoading?'but-loading':'')" @click="dataFormSubmit()">
            <i class="el-icon-loading" v-if="butLoading"></i>
            确定
          </div>
        </div>
    </span>
  </el-dialog>
</template>

<script>
import {formatDate} from '@/utils/validate'
export default {
  data () {
    return {
      visible: false,
      butLoading: false,
      overhaulList: [
        {
          label: '提前1天',
          value: 1
        }, {
          label: '提前3天',
          value: 3
        }, {
          label: '提前7天',
          value: 7
        }
      ],
      dataForm: {
        id: 0,
        repairContent: '',
        nextOverhaulTime: '',
        overhaulRemind: 1,
        overhaulResponsible: ''
      },
      preId: 0,
      dataRule: {
        repairContent: [
          { required: true, message: '维保修内容不能为空', trigger: 'blur' }
        ],
        nextOverhaulTime: [
          { required: true, message: '下次维修日期不能为空', trigger: 'blur' }
        ],
        overhaulResponsible: [
          { required: true, message: '检维修负责人不能为空', trigger: 'blur' }
        ]
        // overhaulRemind: []
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() <= (Date.now())
        }
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.formatData()
        if (this.dataForm.id) {
          // this.$refs['dataForm'].resetFields()
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/front/sys/productequipment/pmequipment/pmequipmentrepairinfo/info/${this.dataForm.id}`)
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.dataForm = data.data
            this.dataForm.nextOverhaulTime = formatDate(data.data.nextOverhaulTime)
          } else {
            this.formatData()
          }
        })
        .catch(() => {
          this.formatData()
        })
    },
    // 表单提交
    dataFormSubmit () {
      if (this.butLoading) {
        return false
      }
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.butLoading = true
          this.$http.post(`/front/sys/productequipment/pmequipment/pmequipmentrepairinfo/finishEquipmentRepairStatus`,
            {
              'id': this.preId,
              'repairContent': this.dataForm.repairContent,
              'nextOverhaulTime': this.dataForm.nextOverhaulTime,
              'overhaulRemind': this.dataForm.overhaulRemind,
              'overhaulResponsible': this.dataForm.overhaulResponsible
            }
          ).then(({ data }) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  // this.visible = false
                  this.closeHandle()
                  this.$emit('refreshData')
                }
              })
            } else {
              this.butLoading = false
            }
          })
          .catch(() => {
            this.butLoading = false
          })
        }
      })
    },
    formatData () {
      this.dataForm.repairContent = ''
      this.dataForm.nextOverhaulTime = ''
      this.dataForm.overhaulRemind = 1
      this.dataForm.overhaulResponsible = ''
    },
    closeHandle () {
      this.visible = false
      this.dataForm = {
        id: '',
        repairContent: '',
        nextOverhaulTime: '',
        overhaulRemind: 1,
        overhaulResponsible: ''
      }
      this.preId = 0
      this.butLoading = false
    }
  }
}
</script>
<style scoped>
.row{
  display: flex;
  line-height: 24px;
  font-size: 14px;
  margin-bottom: 12px;
}
.row-item-label{
  display: inline-block;
  width: 130px;
  text-align: right;
  color: #666;
}
.row-item-content{
  width: 100%;
  word-wrap: break-word;
  word-break: break-all;
  padding-left: 10px;
  color: #333;
}
.line {
  margin-left: 7.5px;
  position: absolute;
  border: 1px dashed #CACACA;
  height: 100%;
  width: 1px;
  z-index: 10;
}
.circular{
  width: 16px; height: 16px; border-radius: 50%; background: #fff; background-color: #CACACA;
}
.opt-but{
  cursor: pointer;
  display: flex;
  margin-top: 40px;
  width: 530px;
  margin-left: -20px;
  margin-bottom: -20px;
  font-size: 16px;
  border: 1px solid #1D65A8;
  text-align: center;
  user-select: none;
}
.upload-cancel{
  flex: 1;
  line-height: 52px;
  color: #1D65A8;
}
.upload-ok{
  width: 265.5px;
  border-radius: 0;
  height: 52px;
  background: #1D65A8;
  color: white;
  line-height: 50px;
  flex: 1;
  font-size: 16px;
  font-weight: normal;
}
.close-but{
  cursor: pointer;
  background: #1D65A8;
  width: 160px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  color: #fff;
  font-size: 16px;
  margin: 0 auto;
}
.but-loading{
  opacity: 0.5;
  cursor: not-allowed;
}
</style>

